import { getUrlParamRaw } from 'components/Dashboard/utilities/getUrlParam';

const returnParamValue = (property) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(property) ? decodeURIComponent(getUrlParamRaw(property)).split(',') : [];
};

export default returnParamValue;
